import { DictionaryItemDto } from 'types/employee/enums/DictionaryItemDto';

function filterProjectsByName(projects: DictionaryItemDto[], namesToExclude: string[]) {
  return projects.filter((project) => !namesToExclude.includes(project.name));
}

export default filterProjectsByName;
